export const config = {
  MIN_BALANCE_THRESHOLD_MULTIPLE: 21,
};
